module.exports = function() {
  return new Worker(__webpack_public_path__ + "a75322930291fb5bee6d.worker.js");
};